import React, { useEffect, useState } from "react";
import axios from "axios";
import Loader from "../../Components/Loader";
import AnimationSection from "../../Components/AnimationSection";
import Stepper from "./Stepper";
import "./TravelClaim.css";

const TravelClaim = () => {
  const [data, setData] = useState();
  useEffect(async () => {
    const home = await axios.get(
      "https://staging-cms-main.ipurvey.com/homepage"
    );
    setData(home.data);
  }, []);
  if (data) {
    return (
      <div className="home_steper_animation">
        <AnimationSection data={data} forms={<Stepper data={data} />} />
      </div>
    );
  } else {
    return <Loader />;
  }
};

export default TravelClaim;
